export default "__VITE_ASSET__DGRmYCJS__"